// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GAEvents from "../../../library/ga/GAEvents.bs.js";
import * as RnrRoutes from "../routing/RnrRoutes.bs.js";
import * as EventUtils from "../../../library/partner-app-events/EventUtils.bs.js";
import * as RnrVMMapper from "./VMMapper/RnrVMMapper.bs.js";
import * as RnrRouteManager from "../routing/RnrRouteManager.bs.js";
import * as RnrHomeComponent from "./RnrHomeComponent.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as Languages$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";
import * as RescriptReactRouter from "../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as RnrHistoryComponent from "./RnrHistoryComponent.bs.js";
import * as RnrCouponTncComponent from "./RnrCouponTncComponent.bs.js";
import * as PartnerAppEventsConfig from "../../../library/partner-app-events/PartnerAppEventsConfig.bs.js";
import * as VernacularModuleManager from "./RnrLocales/VernacularModuleManager.bs.js";
import * as RnrLoginHoursRewardComponent from "./RnrRewardScreens/RnrLoginHoursRewardComponent.bs.js";
import * as RnrCustomerServiceRewardComponent from "./RnrRewardScreens/RnrCustomerServiceRewardComponent.bs.js";
import * as RnrOrderFulfilmentRewardComponent from "./RnrRewardScreens/RnrOrderFulfilmentRewardComponent.bs.js";

function getLocaleContentRepo(language) {
  var RepoInstance = VernacularModuleManager.getContentModule(language);
  return Curry._1(RepoInstance.getContent, undefined);
}

var initialURL = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);

function getInitialState(uuid) {
  var route = RnrRouteManager.RouteManager.getRouteFromURL(initialURL);
  var route$1 = route !== undefined ? route : ({
        TAG: /* RnrHome */0,
        _0: uuid,
        _1: undefined,
        _2: undefined,
        _3: undefined
      });
  return {
          route: route$1
        };
}

function RnrDashboard$RnrDashboard(Props) {
  var rnrReport = Props.rnrReport;
  var refreshView = Props.refreshView;
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  var match = React.useReducer((function (_state, action) {
          return {
                  route: action._0
                };
        }), getInitialState(rnrParams.uuid));
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          var watcherID = RescriptReactRouter.watchUrl(function (url) {
                var route = RnrRouteManager.RouteManager.getRouteFromURL(url);
                if (route !== undefined) {
                  return Curry._1(dispatch, /* UpdateView */{
                              _0: route
                            });
                }
                
              });
          return (function (param) {
                    return RescriptReactRouter.unwatchUrl(watcherID);
                  });
        }), []);
  React.useEffect((function () {
          EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.reward_program_page_loaded, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
          
        }), []);
  var viewModel = RnrVMMapper.getViewModel(rnrReport);
  var content = getLocaleContentRepo(Languages$Catalyst.fromCode(rnrParams.lang));
  var match$1 = state.route;
  switch (match$1.TAG | 0) {
    case /* RnrHome */0 :
        return React.createElement(RnrHomeComponent.make, {
                    viewModel: viewModel,
                    refreshView: refreshView,
                    content: content
                  });
    case /* RnrReward */2 :
        GAEvents.publishPageView(RnrRoutes.getRoutePathString(state.route), RnrRoutes.getRouteTitleString(state.route), undefined);
        switch (match$1._1) {
          case /* CustomerService */0 :
              return React.createElement(RnrCustomerServiceRewardComponent.make, {
                          viewModel: viewModel,
                          content: content
                        });
          case /* LoginActivity */1 :
              return React.createElement(RnrLoginHoursRewardComponent.make, {
                          viewModel: viewModel,
                          content: content
                        });
          case /* OrderFulfillment */2 :
              return React.createElement(RnrOrderFulfilmentRewardComponent.make, {
                          viewModel: viewModel,
                          content: content
                        });
          
        }
    case /* RewardHistory */1 :
    case /* AwardHistory */3 :
        break;
    case /* Tnc */4 :
        GAEvents.publishPageView(RnrRoutes.getRoutePathString(state.route), RnrRoutes.getRouteTitleString(state.route), undefined);
        return React.createElement(RnrCouponTncComponent.make, {
                    viewModel: viewModel,
                    milestone: match$1._1,
                    content: content
                  });
    
  }
  return React.createElement(RnrHistoryComponent.make, {
              viewModel: viewModel,
              content: content
            });
}

var RnrDashboard = {
  getLocaleContentRepo: getLocaleContentRepo,
  initialURL: initialURL,
  getInitialState: getInitialState,
  make: RnrDashboard$RnrDashboard
};

export {
  RnrDashboard ,
  
}
/* initialURL Not a pure module */
